import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Treasury Payout", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "nes-field mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "destination" }, "Payout destination:", -1)
const _hoisted_6 = { class: "nes-field mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "lamports" }, "Amount to pay out (lamp):", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "mb-5 nes-btn is-primary",
  type: "submit"
}, "Payout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "Treasury balance: " + _toDisplayString(_ctx.balance) + " lamports", 1),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.payoutFromTreasury && _ctx.payoutFromTreasury(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          id: "destination",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.destination) = $event)),
          class: "nes-input"
        }, null, 512), [
          [_vModelText, _ctx.destination]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          id: "lamports",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lamports) = $event)),
          class: "nes-input"
        }, null, 512), [
          [_vModelText, _ctx.lamports]
        ])
      ]),
      _hoisted_8
    ], 32)
  ]))
}